interface Params {
  url: string;
  /** 当前图片父组件ref */
  domRef?: any;
  /** 当前固定宽度 */
  imgWidth?: number;
}
/** 判断是否为图片链接正则 */
const imgRegex = /(\.jpg|\.jpeg|\.png|\.gif)/i;
/** 插入链接参数方法 */
export const insertParamToImageLink = (url: string, param: any) => {
  const regex = /(\.jpg|\.jpeg|\.png|\.gif)(\?.*)?$/i;
  const match = regex.exec(url);
  if (match) {
    const index = match.index + match[1].length;
    const prefix = url.slice(0, index);
    const suffix = url.slice(index);
    if (match[2]) {
      return `${prefix}?${param}&${suffix.replace('?', '')}`;
    }
    return `${prefix}?${param}${suffix}`;
  }
  return url;
};
/** 根据父元素的class或者ref获取图片宽度 */
export const getImageWidth = (domRef?: any) => {
  let width = window?.screen?.width;
  const devicePixelRatio = window?.devicePixelRatio; // 获取设备像素比
  if (domRef?.current?.clientWidth) width = domRef?.current?.clientWidth;
  if (typeof domRef === 'string')
    width = document?.getElementsByClassName(domRef)?.[0]?.clientWidth;
  const imgWidth = (width * devicePixelRatio) / 2; // 计算当前显示图片宽度
  return imgWidth;
};
/** 根据当前cos链接与dom宽度返回合适图片大小 */
export const formatUrl = ({ url, domRef, imgWidth }: Params) => {
  const isImage = imgRegex.test(url);
  const imageWidth = imgWidth || getImageWidth(domRef);
  if (isImage && imageWidth) {
    const param = `imageMogr2/thumbnail/${imageWidth}x/quality/90`;
    return insertParamToImageLink(url, param);
  }
  return url;
};
/** 根据当前cos链接返回webp格式 */
export const formatUrlFormatWebp = (url: string, width?: number) => {
  const isImage = imgRegex.test(url);
  if (isImage) {
    let param = 'imageMogr2/format/webp';
    if (width) {
      param += `/thumbnail/${width}x/quality/90`;
    } else {
      param += '/quality/90';
    }
    return insertParamToImageLink(url, param);
  }
  return url;
};

export const formatUrlFoWebpNotJudge = (url: string, width?: number) => {
  if (url) {
    let param = 'imageMogr2/format/webp';
    if (width) {
      param += `/thumbnail/${width}x/quality/90`;
    } else {
      param += '/quality/90';
    }

    if (url.indexOf('?') > -1) {
      return `${url}&${param}`;
    }

    return `${url}?${param}`;
  }
  return url;
};

/** 根据当前cos链接与dom宽度返回合适图片大小 */
export const formatUrlNotJudge = ({ url, domRef, imgWidth }: Params) => {
  // const isImage = imgRegex.test(url);
  const imageWidth = imgWidth || getImageWidth(domRef);
  if (imageWidth) {
    const param = `imageMogr2/thumbnail/${imageWidth}x/quality/90`;
    // return insertParamToImageLink(url, param);
    if (url.indexOf('?') > -1) {
      return `${url}&${param}`;
    }

    return `${url}?${param}`;
  }
  return url;
};
